import { distinct, objectAdd } from '@/lib/utils'
import config from '@/config'

export function mergeCosts(a, b) {
  b.forEach((e) => {
    const found = a.find((e2) => e.currency === e2.currency)
    if (found) {
      objectAdd(found, e, true)
    } else {
      a.push(JSON.parse(JSON.stringify(e)))
    }
  })

  return a
}

export function makeTotalData(data) {
  data.forEach((d) => {
    const total = { project_id: '__total', project_name: '', data: [] }

    const merged = [].concat(...d.data.map((e) => e.data))
    if (merged.length === 0) {
      d.data.push(total)
      return
    }

    const keys = Object.keys(merged[0]).filter(
      (k) => k !== 'usage' && k !== 'costs'
    )
    merged.forEach((m) => {
      const found = total.data.find((td) => keys.every((k) => td[k] === m[k]))
      if (found) {
        if (found.usage && m.usage) {
          found.usage += m.usage
        }
        if (found.costs && m.costs) {
          found.costs = mergeCosts(found.costs, m.costs)
        }
      } else {
        total.data.push(JSON.parse(JSON.stringify(m)))
      }
    })

    d.data.push(total)

    if (config.feature.costByRegion) {
      if (d.kind === 'cost_by_region') {
        d.data.forEach((d2) => {
          d2.data.forEach((d3) => {
            const multiRegionFlag = '*'
            d3.region_name = d3.multi_region
              ? d3.region_id.concat(multiRegionFlag)
              : d3.region_id
          })
        })
      }
    }
  })
  return data
}

export function getKindData(data, kind, projectId) {
  if (data) {
    const kindData = data.find((d) => d.kind === kind)
    if (kindData) {
      if (!projectId) {
        return kindData.data
      }
      const projectData = kindData.data.find((d) => d.project_id === projectId)
      return projectData ? projectData.data : []
    }
  }
  return []
}

export function getProject(data, userInfo, account) {
  const project = {
    all: false,
    list: [],
  }
  if (data && userInfo && account) {
    const billingProjects = distinct(
      [].concat(
        ...data.map((d) =>
          d.data.map((d2) => ({
            id: d2.project_id,
            name: d2.project_name,
          }))
        )
      )
    ).filter((p) => p.id !== '__total')

    if (
      userInfo.resource.allAccount ||
      userInfo.resource.projects[account.id].includes('*')
    ) {
      project.all = true
      if (billingProjects.length > 0) {
        project.list.push(...billingProjects)
      }
    } else {
      userInfo.resource.projects[account.id].forEach((id) => {
        const item = billingProjects.find((p) => p.id === id)
        if (item) {
          project.list.push(item)
        }
      })
    }
    project.list.sort((a, b) => a.name.localeCompare(b.name))
  }
  return project
}

export function getBytesUnit(bytes) {
  const scale = Math.floor(Math.log2(bytes) / 10)
  switch (scale) {
    case NaN:
    case 0:
      return { unit: 'Bytes', scale: 1 }
    case 1:
      return { unit: 'Kibibytes', scale: 1024 }
    case 2:
      return { unit: 'Mebibytes', scale: 1024 * 1024 }
    case 3:
    default:
      return { unit: 'Gibibytes', scale: 1024 * 1024 * 1024 }
  }
}

export function sumUsage(data, filterFunc) {
  return data.filter(filterFunc).reduce((p, v) => p + v.usage, 0)
}

export default {
  mergeCosts,
  makeTotalData,
  getKindData,
  getProject,
  getBytesUnit,
  sumUsage,
}
